// removed by extract-text-webpack-plugin
module.exports = {"defaultInput":"_2kmqdAig","container":"_3Iz6A2fz","active":"yWi6RJ9j","checkmark":"RfFg85hu","paypal":"_1Zp2r3bh"};


//////////////////
// WEBPACK FOOTER
// ./src/client/webapp/components/PaymentOptions/PaymentOptions.styl
// module id = 517
// module chunks = 0